var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"10px"}},[_vm._v(" 历史订单 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }